<template>
  <div>

    <base-header class="pb-6 bg-light">

      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0 text-dark">HSS Activate</h6> &nbsp;
        </b-col>
        <b-col cols="5" lg="6" class="text-right">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>

      <b-row>
        <b-col xl="6">
          <div class="input-group">
            <b-input-group>
              <template #prepend>
                <b-input-group-text :style="ps">ICCID</b-input-group-text>
              </template>
              <b-form-input id="iccid" type="text" v-model="iccid" @change="getProfileData"></b-form-input>
              <template #append>
                <base-button size="lg" type="light" title="Search" v-on:click="getProfileData">
                  <i class="fa fa-search"></i>
                </base-button>
              </template>
            </b-input-group>
          </div>
          <br>
        </b-col>
        <b-col xl="6"></b-col>
      </b-row>

      <b-row v-if="!hasData">
        <b-col xl="12">
          <b-card no-body>
            <b-card-body>
              <div v-if="submitLoading" class="text-center">
                <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
              </div>
              <div  v-if="!submitLoading"  class="text-center">
                Please enter a valid iccid that exists in the system.
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="hasData">
        <b-col xl="6">
          <b-card>
            <b-card-body>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">ICCID</b-input-group-text>
                  </template>
                  <b-form-input id="iccid" type="number" v-model="dataSrc.iccid" disabled></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">IMSI</b-input-group-text>
                  </template>
                  <b-form-input id="imsi" type="number" v-model="dataSrc.imsi"></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">MSISDN</b-input-group-text>
                  </template>
                  <b-form-input id="msisdn" type="tel" v-model="dataSrc.msisdn" maxlength="12"></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">SUBSCRIBER NAME</b-input-group-text>
                  </template>
                  <b-form-input id="hss_subscribername" type="text" v-model="dataSrc.hss_subscribername" maxlength="100"></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">STATIC IP</b-input-group-text>
                  </template>
                  <b-form-input id="hss_staticip" type="text" v-model="dataSrc.hss_staticip"></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">HSS PROFILE</b-input-group-text>
                  </template>
                  <b-form-select id="hss_profile" v-model="dataSrc.hss_profile" :options="dataSrc.lteTemplates"></b-form-select>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">BARRING TEMPLATE</b-input-group-text>
                  </template>
                  <b-form-select id="barringTemplate" v-model="dataSrc.barringTemplate" :options="dataSrc.barringTemplates"></b-form-select>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">KI</b-input-group-text>
                  </template>
                  <b-form-input id="ki" type="text" v-model="dataSrc.ki"></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">OPC</b-input-group-text>
                  </template>
                  <b-form-input id="opc" type="text" v-model="dataSrc.opc"></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">PIN</b-input-group-text>
                  </template>
                  <b-form-input id="pin1" type="text" v-model="dataSrc.pin1"></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">PUK</b-input-group-text>
                  </template>
                  <b-form-input id="puk1" type="text" v-model="dataSrc.puk1"></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">CSS PROFILE</b-input-group-text>
                  </template>
                  <b-form-input id="cssProfile" type="text" v-model="dataSrc.cssProfile" disabled></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">ROAMING PROFILE</b-input-group-text>
                  </template>
                  <b-form-input id="roamingProfile" type="text" v-model="dataSrc.roamingProfile" disabled></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">HLR TEMPLATE</b-input-group-text>
                  </template>
                  <b-form-input id="hlrTemplate" type="text" v-model="dataSrc.hlrTemplate" disabled></b-form-input>
                </b-input-group>
              </div>
              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">IMS TEMPLATE</b-input-group-text>
                  </template>
                  <b-form-input id="imsTemplate" type="text" v-model="dataSrc.imsTemplate" disabled></b-form-input>
                </b-input-group>
              </div>

              <div class="input-group">
                <b-input-group>
                  <template #prepend>
                    <b-input-group-text :style="ps">OPERATOR</b-input-group-text>
                  </template>
                  <b-form-input id="operatorName" type="text" v-model="dataSrc.operatorName" disabled></b-form-input>
                </b-input-group>
              </div>

              <br>&nbsp;

              <div class="text-right" v-if="!recordUpdating">
                <base-button v-if="dataSrc.status==='Active'" size="xl" type="warning"
                             v-on:click="activateAction(1)">
                  Reset Subscriber
                </base-button>
                <base-button v-if="dataSrc.status!=='Active'" size="xl" type="success"
                             v-on:click="activateAction(0)">
                  Activate Subscriber
                </base-button>
              </div>

              <div class="text-right" v-if="recordUpdating">
                <b-button class="btn btn-primary" size="sm" variant="primary" disabled>
                  <b-icon icon="circle-fill" animation="throb" font-scale="1"></b-icon>
                  Activating...
                </b-button>
              </div>

            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </base-header>

  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import hssDashboardService from "@/common/api-services/hss-dashboard-service";
import commonService from "@/common/api-services/common";
import ToastVue from '../../Components/Toast.vue';
export default {
  components: {
    RouteBreadCrumb,
    ToastVue
  },

  data() {
    return {
      ps: 'background-color:rgba(94,114,228);color:#FFFFFF;width:200px !important;',
      submitLoading: false,
      iccid: '',
      hasData: false,
      dataSrc: [],
      recordUpdating: false,
    }
  },

  watch: {
    msisdn: {
      handler: function (value) {
        this.msisdn = commonService.formatPhone(value);
      },
    }, mdn: {
      handler: function (value) {
        this.mdn = commonService.formatPhone(value);
      },
    },
    min: {
      handler: function (value) {
        this.min = commonService.formatPhone(value);
      },
    },
  },

  mounted() {
    document.title = 'HSS - Activate';
    this.loadPageData();
  },

  methods: {

    async loadPageData() {
      try {
        this.iccid = this.$route.query.iccid;
        if (!this.iccid || this.iccid.length !== 20) {
          throw new Error('Invalid ICCID.');
        } else {
          this.getProfileData();
        }
      } catch (e) {
        //this.showToasterMsg('[loadPage]Error:' + e.message, true, 'danger');
      }
    },

    async activateAction(retry) {
      this.recordUpdating=true;

      let data = this.dataSrc;
      data.retry = retry;
      delete data.lteTemplates;
      delete data.barringTemplates;

      console.log(data);

      await hssDashboardService.activate(data).then(res => {
        console.log(res);
        if (res.data.message.hasOwnProperty("error")) {
          throw res.data.message.error + ': ' + res.data.message.error_string;
        } else {
          console.log('Activation OK:',res);
          this.showToasterMsg("Activation was successful for: "+this.iccid);
        }
      }).catch(e => {
        console.error('Activation error:',e);
        let msg = "The activation failed with message:\"" + e + "\"";
        if (retry > 0) {
          this.showToasterMsg(msg,false,'error');
        } else {
          msg+="  Would you like to retry?";
          this.$bvModal.msgBoxConfirm(msg, {
            title: 'Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'RETRY',
            cancelTitle: 'CANCEL',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
            .then(value => {
              if (value === true) {
                this.activateAction(1);
              }
            });
        }
      });
      this.recordUpdating=false;
    },

    async getProfileData() {
      this.submitLoading = true;
      await hssDashboardService.getsubscribersettings(this.iccid).then(res => {
        console.log(res);
        if (res.data.message.result) {
          this.dataSrc = res.data.message.result;
          this.hasData = true;
        } else {
          this.dataSrc=[];
          this.hasData = false;
        }
      }).catch(e=>{
        this.dataSrc=[];
        this.hasData = false;
        console.log(e);
      }).finally(x=>{
        this.submitLoading = false;
      });
    },


    refreshPage() {
      setTimeout(() => {
        this.dataSrc = null;
        this.loadPageData();
      }, 1000);
    },

    showToasterMsg(message, append = false, variant = 'success') {
      //commonService.showToasterMsg(message, append, variant);
      this.$toast({
        component: ToastVue,
        props: {
          description: message
        }
      }, {
        type: variant
      })
    },
  },
}

</script>

